import React from 'react';
import { posts } from './data/posts';
import BurningMan2025PackingList from './articles/BurningMan2025PackingList';
import BurningManBikeIdeas from './articles/BurningManBikeIdeas';

const HERO_IMG = 'https://images.unsplash.com/photo-1506126613408-eca07ce68773?auto=format&fit=crop&w=1350&q=80';

export default function App() {
  const path = window.location.pathname;
  if (path === '/burning-man-2025-packing-list') {
    return <BurningMan2025PackingList />;
  }
  if (path === '/burning-man-bike-ideas') {
    return <BurningManBikeIdeas />;
  }

  return (
    <main style={{ fontFamily: 'sans-serif', lineHeight: 1.6 }}>
      <section
        style={{
          position: 'relative',
          textAlign: 'center',
          color: '#fff',
          marginBottom: '2rem',
        }}
      >
        <img
          src={HERO_IMG}
          alt="Burning Man art on the playa"
          style={{
            width: '100%',
            height: '60vh',
            objectFit: 'cover',
            filter: 'brightness(70%)',
          }}
        />
        <div
          style={{
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            maxWidth: '90%',
          }}
        >
          <h1 style={{ fontSize: '3rem', margin: 0 }}>BurnerGuide</h1>
          <p style={{ fontSize: '1.25rem', marginTop: '1rem' }}>
            Your essential companion for prepping the playa.
          </p>
        </div>
      </section>

      <section style={{ padding: '0 2rem', maxWidth: 800, margin: '0 auto' }}>
        <p>
          Getting ready for Burning Man? We've curated essential advice and gear to
          help you stay safe and make the most of your time in Black Rock City.
        </p>
        <h2>Articles</h2>
        <ul style={{ listStyle: 'none', padding: 0 }}>
          {posts.map((post) => (
            <li key={post.path} style={{ margin: '1rem 0' }}>
              <a
                href={post.path}
                style={{ textDecoration: 'none', color: 'inherit' }}
              >
                <h3 style={{ margin: '0 0 0.25rem 0' }}>{post.title}</h3>
                <p style={{ margin: 0 }}>{post.description}</p>
              </a>
            </li>
          ))}
        </ul>
      </section>
    </main>
  );
}

